import {
  animate,
  query,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Input, TemplateRef } from '@angular/core';

export const TIMELINESTAGGER = 500;

export interface TimeLineItem {
  title: string;
  content: string;
  type: 'text' | 'img';
}

@Component({
  selector: 'canvas-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', [
          style({ opacity: 0 }),
          stagger(TIMELINESTAGGER, [animate('0.5s', style({ opacity: 1 }))]),
        ]),
      ]),
    ]),
  ],
  standalone: false,
})
export class TimelineComponent {
  @Input() stagger = true;
  @Input() templateTimelineItems: TemplateRef<TimelineComponent>[] = [];
  @Input() timelineItems: TimeLineItem[] = [];
}
